module.exports = __webpack_public_path__ + "media/images/pepsi_digin_day/green-location-icon-c1b3d99485f6b80af17eeb23b31b4cf4.png";